export default {
  features: {
    clientSendToReview: {
      button: 'Ko‘rib chiqishga yuborish',
    },
  },
};
